import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "inline-flex items-center space-x-1 md:space-x-3" }
const _hoisted_2 = { class: "flex items-center" }
const _hoisted_3 = {
  key: 0,
  class: "icon-chevron_destra text-xs"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("ol", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paths, (p, i) => {
      return (_openBlock(), _createElementBlock("li", { key: i }, [
        _createElementVNode("div", _hoisted_2, [
          i
            ? (_openBlock(), _createElementBlock("i", _hoisted_3))
            : _createCommentVNode("", true),
          _createVNode(_component_router_link, {
            to: p,
            "exact-active-class": "text-next-orange font-bold no-underline",
            class: _normalizeClass([{'ml-1 md:ml-2': i}, "underline text-sm hover:text-next-gray-300"])
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(p.title), 1)
            ]),
            _: 2
          }, 1032, ["to", "class"])
        ])
      ]))
    }), 128))
  ]))
}